import { useEffect } from "react";
import { Typography, Stack } from '@mui/material';

export const INSTRUCTIONS = [
    {
        title: "Stable Internet Connection",
        content: "Ensure a strong and reliable internet connection throughout the exam. Wired connection is recommended over Wi-Fi."
    },
    {
        title: "Computer Requirements",
        content: "Use a desktop or laptop computer with sufficient processing power and a stable operating system. Mobile devices are not permitted."
    },
    {
        title: "Power Supply",
        content: "Connect your laptop to a power source or have a fully charged battery to avoid interruptions."
    },
    {
        title: "Data Allowance",
        content: "Confirm sufficient data quota with your internet service provider to cover the entire exam duration."
    },
    {
        title: "Early Login",
        content: "Access the exam portal 10 minutes before the scheduled start time for a smooth login process."
    },
    {
        title: "Clear Browser",
        content: "Close all unnecessary browser tabs and programs before the exam to avoid distractions and potential disruptions."
    },
    {
        title: "Focus on the Exam",
        content: "During the exam, minimize any activity outside the exam window. Switching to other applications or tabs may be considered malpractice and lead to disqualification."
    },
    {
        title: "Dedicated Environment",
        content: "Choose a quiet and well-lit room free from distractions and unauthorized individuals. Cell phones and other electronic devices are prohibited in the testing area."
    },
    {
        title: "Organized Workspace",
        content: "Clear your desk/table of any unnecessary materials except for permitted resources like a blank sheet of paper for calculations."
    },
    {
        title: "Silent Mode",
        content: "Maintain silence throughout the exam and avoid communication with anyone during the testing period."
    },
    {
        title: "Calculator Restriction",
        content: "Standard or scientific calculators are not allowed. Only the provided on-screen calculator, if available, can be used."
    },
]

export const EXAM_PATTERN = [
    "The exam consists of 100 multiple-choice questions.",
    "Each question will have four answer options.",
    "Answer the questions by selecting the correct option displayed on the right side of your screen."
]

export const TIMING_AND_MARKING = [
    "The exam duration is 90 minutes.",
    "The remaining time will be displayed clearly on the top of your screen.",
    "There is no negative marking, so please attempt all questions.",
    "Feel free to edit your answers as needed before the exam end time.",
    "Your responses will be automatically saved throughout the assessment.",
    "After the exam ends, you can login again and check your score."
]

export const QUALIFICATION_AND_NEXT_STEPS = [
    "Only candidates who qualify in this preliminary round will be eligible to participate in the Statistics Olympiad finals.",
    "The final round will be held in June.",
    "We will communicate the format and details of the finals to all eligible participants via email in due course."
]

export default function Instructions() {

    useEffect(() => {
        window.document.title = 'Instructions'
        return () => { window.document.title = process.env.REACT_APP_NAME }
    }, [])

    return (
        <Stack spacing={2}>
            <Typography variant="h5" fontWeight={"bold"} align="center">
                Instructions
            </Typography>
            {INSTRUCTIONS.length > 0 && INSTRUCTIONS.filter(x => x?.title && x?.content && x).map((x, index) => (
                <Stack spacing={1} key={x.title}>
                    <Typography variant="subtitle1" fontWeight={"medium"}>
                        {index + 1}. {x.title}
                    </Typography>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        {x.content}
                    </Typography>
                </Stack>
            ))}
            <Typography variant="h5" fontWeight={"bold"} align="center">
                Exam Pattern
            </Typography>
            {EXAM_PATTERN.length > 0 && EXAM_PATTERN.map((x, index) => (
                <Typography key={x} variant="subtitle1" fontWeight={"medium"}>
                    {index + 1}. {x}
                </Typography>
            ))}
            <Typography variant="h5" fontWeight={"bold"} align="center">
                Timing & Marking
            </Typography>
            {TIMING_AND_MARKING.length > 0 && TIMING_AND_MARKING.map((x, index) => (
                <Typography key={x} variant="subtitle1" fontWeight={"medium"}>
                    {index + 1}. {x}
                </Typography>
            ))}
            <Typography variant="h5" fontWeight={"bold"} align="center">
                Qualification & Next steps
            </Typography>
            {QUALIFICATION_AND_NEXT_STEPS.length > 0 && QUALIFICATION_AND_NEXT_STEPS.map((x, index) => (
                <Typography key={x} variant="subtitle1" fontWeight={"medium"}>
                    {index + 1}. {x}
                </Typography>
            ))}
        </Stack>
    );
}